import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";
import { BASE_URL } from "../constants";

const base = `${BASE_URL}/api/v1/super`;

export const getSuperAdminClinics = (params?: any) =>
  api.get(`${base}/clinics`, { params });

export const getSuperAdminClinic = (id: number) =>
  api.get(`${base}/clinics/${id}`);

export const createSuperAdminClinic = (payload: any) =>
  api.post(`${base}/clinics`, camelToSnake(payload));

export const updateSuperAdminClinic = (id: number, payload: Record<string, any>) =>
  api.patch(`${base}/clinics/${id}`, camelToSnake(payload));

export const toggleClinicActive = (id: number) =>
  api.patch(`${base}/clinics/${id}/toggle-active`);

export const updateSuperAdminClinicPlan = (clinicId: number, payload: Record<string, any>) =>
  api.patch(`${base}/clinics/${clinicId}/plan`, payload);

export const getSuperAdminClinicConfig = (clinicId: number) =>
  api.get(`${base}/clinics/${clinicId}/config`);

export const updateSuperAdminClinicConfig = (clinicId: number, payload: Record<string, any>) =>
  api.patch(`${base}/clinics/${clinicId}/config`, payload);

export const getSuperAdminClinicUsers = (clinicId: number) =>
  api.get(`${base}/clinics/${clinicId}/users`);

export const createSuperAdminClinicUser = (clinicId: number, payload: any) =>
  api.post(`${base}/clinics/${clinicId}/users`, camelToSnake(payload));

export const getSuperAdminLogs = (params?: { lines?: number; level?: string }) =>
  api.get(`${base}/logs`, { params });
